import {LookupTablesStore} from 'common/report/stores/lookup-tables';
import {contextify} from 'common/util/react';

const context = contextify<LookupTablesStore>();

export const LookupTablesProvider = context.Provider;
export const LookupTablesConsumer = context.Consumer;
export const useLookupTables = context.hook;
